<template>
  <div>
    <h2>Strategies <span v-if="!loadingResources" class="count">({{ displayedStrategies.length }})</span></h2>
    <subject-filter
      :subjects="filterOptions"
      :resource="resourceType"
      :page="pageType"/>
    <p v-if="displayedStrategies.length === 0 && !shared" class="empty-notice"><router-link :to="{name: 'BrowseStrategiesPage'}">Find some strategies</router-link></p>
    <p class="text-muted" v-if="filtering"><i class="fa fa-circle-o-notch fa-spin"/>&nbsp;Loading strategies...</p>
    <br>
    <div v-if="!filtering">
      <div :key="strategy.uuid" v-for="strategy in displayedStrategies">
        <LibraryStrategyCard
          :shared="shared"
          :student-name="allStrategies ? strategy.student_name : ''"
          :strategy="strategy"
          :content-uuid="strategy.content_uuid"
          :collection-uuid="strategy.collection_uuid"/>
      </div>
    </div>
  </div>
</template>

<script>
import LibraryStrategyCard from '@/components/library/LibraryStrategyCard'
import SubjectFilter from '@/components/favorites/SubjectFilter'
import { mapState } from 'vuex'
import { getStrategyTags } from '@/api/strategies'

export default {
  name: 'StrategyLibrary',
  components: {
    LibraryStrategyCard,
    SubjectFilter
  },
  props: {
    strategies: {
      type: Array,
      required: true
    },
    context: {
      type: String,
      default: ''
    },
    shared: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      resourceType: 'strategies',
      pageType: 'library',
      strategySubjects: [],
      filtering: false
    }
  },
  computed: {
    ...mapState('library', ['filters', 'loadingResources']),
    displayedStrategies() {
      let strategies =
        this.filterStrategiesBySubject(this.strategies, this.filters.strategies) || []
      strategies.sort((s1, s2) => {
        if (s1.created_at < s2.created_at) {
          return 1
        }
        if (s1.created_at > s2.created_at) {
          return -1
        }
        return 0
      })
      return strategies.map(strategy => {
        return {
          image_url: strategy.content_body.source_strategy.image_url,
          title: strategy.content_body.source_strategy.title,
          description: strategy.content_body.source_strategy.description,
          updated_at: strategy.content_body.updated_at,
          student_name: strategy.content_body.student_name,
          content_uuid: strategy.content_uuid,
          collection_uuid: strategy.collection_uuid
        }
      })
    },
    filterOptions() {
      var options = ['All Subjects']
      this.strategies &&
        this.strategies.forEach(strategy => {
          strategy.content_body.source_strategy.tags.forEach(tag => {
            if (options.indexOf(tag) === -1 && this.strategySubjects.indexOf(tag) >= 0) {
              options.push(tag)
            }
          })
        })
      return options
    },
    allStrategies() {
      return this.context === 'All Strategies'
    }
  },
  methods: {
    filterStrategiesBySubject(strategies, subject) {
      this.filtering = true
      if (subject === 'All Subjects') {
        window.setTimeout(() => {
          this.filtering = false
        }, 300)
        return [].concat(strategies)
      }
      return strategies.filter((strategy, ind) => {
        if (ind === strategies.length - 1) {
          window.setTimeout(() => {
            this.filtering = false
          }, 300)
        }
        return strategy.content_body.source_strategy.tags.indexOf(subject) > -1
      })
    }
  },
  created() {
    getStrategyTags().then(result => {
      this.strategySubjects = result.subjects
    })
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
.count {
  color: @blue;
  font-weight: 300;
}
.empty-notice {
  font-size: 24px;
}
</style>
